import axios from '../lib/axios';
import { showToast } from "../utils/toast"; // your toast utility

interface FetchLogsParams {
  page: number;
  pageSize: number;
  sortField?: string;
  sortOrder?: "asc" | "desc";
  search?: string;
  token?: string;
  filters?: {
    apiProvider?: string;
    platform?: string;
    id?: string;
    from?: string; // YYYY-MM-DD
    to?: string;   // YYYY-MM-DD
  };
}

interface ExternalApiLog {
  _id: string;
  method: string;
  statusCode: string;
  apiProvider: string;
  apiName: string;
  platform: string;
  user?: string;
  requestBody?: any;
  createdAt: string;
  updatedAt: string;
  serialNumber?: number;
  responseBody?: {
    message?: string;
  };
}

interface FetchLogsResponse {
  logs: ExternalApiLog[];
  totalCount: number;
  totalPages: number;
  pageNo: number;
  pageSize: number;
}

export const fetchLogs = async ({
  page,
  pageSize,
  sortField = "createdAt",
  sortOrder = "desc",
  search,
  token,
  filters = {}
}: FetchLogsParams): Promise<FetchLogsResponse> => {
  try {
    let authToken = token || localStorage.getItem("token") || "";
    if (!authToken) throw new Error("No authentication token available");

    // Build query params
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("pageSize", String(pageSize));
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    if (search) params.append("search", search);
    if (filters.apiProvider) params.append("apiProvider", filters.apiProvider);
    if (filters.platform) params.append("platform", filters.platform);
    if (filters.id) params.append("id", filters.id);
    if (filters.from) params.append("from", filters.from);
    if (filters.to) params.append("to", filters.to);

    const url = `/adminexternal/logs?${params.toString()}`;
    console.log(`[API] Fetching logs with URL: ${url}`);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        token: authToken,
      },
    });

    if (!response.data?.data) {
      throw new Error("Unexpected API response structure");
    }

    const logs = response.data.data.map((log: ExternalApiLog, index: number) => ({
      ...log,
      serialNumber: (page - 1) * pageSize + index + 1
    }));

    return {
      logs,
      totalCount: response.data.total,
      totalPages: response.data.totalPages,
      pageNo: response.data.page,
      pageSize: response.data.pageSize,
    };
  } catch (error: any) {
    console.error("Error fetching logs:", error);
    showToast.error(error.message || "Failed to fetch logs");
    throw error;
  }
};
